// extracted by mini-css-extract-plugin
export default {"closeIcon":"styles_closeIcon__vjeSV"};